import { render, staticRenderFns } from "./statusDetails.vue?vue&type=template&id=647133e1&scoped=true&"
import script from "./statusDetails.vue?vue&type=script&lang=js&"
export * from "./statusDetails.vue?vue&type=script&lang=js&"
import style0 from "./statusDetails.vue?vue&type=style&index=0&id=647133e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647133e1",
  null
  
)

export default component.exports